export type AppErrorCode = 'AUTH' | 'PERMISSION' | 'VALIDATION' | 'CONNECTION' | 'CONFLICT' | 'NOT_FOUND' | 'UNEXPECTED'

export class AppError extends Error {
  readonly code: AppErrorCode

  constructor(code: AppErrorCode, message: string, cause?: unknown) {
    super(message)
    this.name = 'AppError'
    this.code = code
    if (cause && (code === 'CONNECTION' || code === 'UNEXPECTED')) console.error('Diagnóstico técnico:', cause)
    else if (cause) console.warn('Diagnóstico técnico controlado:', cause)
  }

  static isConnection(error: unknown): boolean {
    return error instanceof AppError && error.code === 'CONNECTION'
  }

  static isConflict(error: unknown): boolean {
    return error instanceof AppError && error.code === 'CONFLICT'
  }

  static isNotFound(error: unknown): boolean {
    return error instanceof AppError && error.code === 'NOT_FOUND'
  }
}

export function toUserMessage(error: unknown): string {
  if (error instanceof AppError) return error.message
  return 'Não foi possível concluir a operação.'
}
